import { BrandInterface } from "@swivl-mono/types";
import { Button, ButtonColor, ImageUploader, ImageUploaderType } from "@swivl-mono/ui";
import { useState } from "react";

import { AvatarGeneratorModal } from "./AvatarGeneratorModal";

interface AvatarWithGeneratorProps {
  brandId?: number | string;
  brands?: Record<string, BrandInterface>;
  imageURL?: string;
  onImageUploaded: (url: string) => void;
  isEditable: boolean;
}

export function AvatarWithGenerator({ brandId, brands, imageURL, onImageUploaded, isEditable }: AvatarWithGeneratorProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const brand = brandId && brands ? brands[brandId] : undefined;

  return (
    <div className="flex flex-col items-start">
      <ImageUploader isEditable={isEditable} imageURL={imageURL} type={ImageUploaderType.AVATAR} imageUploaded={onImageUploaded} size={120} round />
      {isEditable && (
        <Button className="mt-2 w-full" color={ButtonColor.WHITE} onClick={() => setIsModalOpen(true)}>
          Generate New Avatar
        </Button>
      )}
      <AvatarGeneratorModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} brand={brand} onAvatarSelected={onImageUploaded} />
    </div>
  );
}
